 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		42: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"3":"component---src-pages-404-js","4":"component---src-pages-about-index-de-js","5":"component---src-pages-about-index-en-js","6":"component---src-pages-about-international-sales-manager-index-de-js","7":"component---src-pages-about-international-sales-manager-index-en-js","8":"component---src-pages-consulting-index-de-js","9":"component---src-pages-consulting-index-en-js","10":"component---src-pages-contact-de-js","11":"component---src-pages-contact-en-js","12":"component---src-pages-data-privacy-de-js","13":"component---src-pages-data-privacy-en-js","14":"component---src-pages-imprint-de-js","15":"component---src-pages-imprint-en-js","16":"component---src-pages-index-de-js","17":"component---src-pages-index-js","18":"component---src-pages-partnership-certified-partner-index-de-js","19":"component---src-pages-partnership-certified-partner-index-en-js","20":"component---src-pages-partnership-index-de-js","21":"component---src-pages-partnership-index-en-js","22":"component---src-pages-products-assemblycontrol-index-de-js","23":"component---src-pages-products-assemblycontrol-index-en-js","24":"component---src-pages-products-index-de-js","25":"component---src-pages-products-index-en-js","26":"component---src-pages-products-metalscanner-index-de-js","27":"component---src-pages-products-metalscanner-index-en-js","28":"component---src-pages-products-paintscanner-index-de-js","29":"component---src-pages-products-paintscanner-index-en-js","30":"component---src-pages-products-toolbox-index-de-js","31":"component---src-pages-products-toolbox-index-en-js","32":"component---src-pages-products-weldscanner-index-de-js","33":"component---src-pages-products-weldscanner-index-en-js","34":"component---src-pages-products-woodscanner-index-de-js","35":"component---src-pages-products-woodscanner-index-en-js","36":"component---src-pages-technology-index-de-js","37":"component---src-pages-technology-index-en-js","38":"component---src-pages-terms-conditions-de-js","39":"component---src-pages-terms-conditions-en-js","40":"component---src-pages-use-cases-index-de-js","41":"component---src-pages-use-cases-index-en-js"}[chunkId]||chunkId) + "-" + {"3":"60664b98a88477b0df28","4":"d356bb8a0ebf2cb50751","5":"fdbd87909f5546107e16","6":"548b0b396c3465eaf704","7":"4dca1e1138afc2e2635c","8":"8c09b5806a858cbe3dce","9":"01064ef989cdeb42680c","10":"5acb32cc61dbf1bb3cbf","11":"d9a97afaa12702ec62dd","12":"d3fdd1ab45ee233fc395","13":"e61c52591c909a88bc23","14":"e86539a57fda7382cda3","15":"6b3760a1eb0e7b48ab8e","16":"03c70efe6a4599c422a6","17":"9372368fc569b8a5c5bc","18":"349d8fe74d3dc7330b00","19":"ae66914318ce3eb2c2bc","20":"075d1504960388afe852","21":"1bcd10e514b800af1790","22":"e735abbd15eb05ffc208","23":"b824619671b6e15c6b0d","24":"c8cca44f86cafccf54bd","25":"945969521b79fe59da03","26":"d04f56835daa9acc05e1","27":"0025adfc44af28063eb1","28":"19069d6bc26dcc16c4cb","29":"80baf9b6587a976b15c4","30":"fd38b2e41c5c29cb8505","31":"c51cfeb1eaf9a3de14ac","32":"177a556887ea765c3b54","33":"c07440582aca3b2f8e5e","34":"8248154732bdc78df21b","35":"770fb2707ef3fdb33449","36":"d579f2929890ed650682","37":"1cf90610043bcaa17621","38":"e4c2af7a88801c4cc8d5","39":"235ef8f0c37d300bec72","40":"e12919fa0367af5f651f","41":"65912aab354f978dfc73"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
